import styles from "./Header.module.scss";
import logo from "../../assets/images/layouts/180x70.png";
import { Link, NavLink, useNavigate } from "react-router-dom";
import MainButton from "../../components/shared/button/MainButton";
import { getCookie } from "../../utils/utils";
import { useEffect, useRef, useState } from "react";
import logoutIcon from "../../assets/images/layouts/SignOut.svg";
import OffcanvasIcon from "../../assets/images/layouts/Menu Icon.svg";
import { useDispatch, useSelector } from "react-redux";

import {
  setIsChangePassword,
  setIsForgetPassword,
  setIsLogin,
  setIsMessage,
  setIsRegister,
  setIsUserStatus,
} from "../../redux/Slices/userSlice";

import bell from "../../assets/images/user-admin-panel/header/notification.svg";
import { fetchUser } from "../../redux/Slices/userProfile";
import { AppDispatch, RootState } from "../../redux/store";
import ReferalModal from "../../components/pages/admin-panels/referal-accounts/referal-modal/ReferalModal";
import LogoutModal from "../../components/shared/logout-modal/LogoutModal";
import Offcanvas from "../offcanvas/Offcanvas";
import userIcon from "../../assets/images/layouts/userion.svg";
import userIcon2 from "../../assets/images/layouts/user.svg";
import barIcon from "../../assets/images/layouts/bars-svgrepo-com (2).svg";
import barIcon2 from "../../assets/images/layouts/bars-svgrepo-com (3).svg";
import LanguageSelect from "../../components/shared/languages-select/LanguagesSelect";
import { useSite } from "../../context/TranslationContext";
import { useLangPath } from "../../hooks/useLangPath";
import map from "../../assets/images/layouts/navigation-icons/MapPinLine.svg";
import box from "../../assets/images/layouts/navigation-icons/Box.svg";
import card from "../../assets/images/layouts/navigation-icons/Cardholder.svg";
import creditCard from "../../assets/images/layouts/navigation-icons/Cardholder.svg";
import filePlus from "../../assets/images/layouts/navigation-icons/FilePlus.svg";
import shoppingCart from "../../assets/images/layouts/navigation-icons/ShoppingCart.svg";
import truck from "../../assets/images/layouts/navigation-icons/Truck.svg";
import Wolt from "../../assets/images/layouts/navigation-icons/wolt.svg";
import mailbox from "../../assets/images/layouts/navigation-icons/Mailbox.svg";
import check from "../../assets/images/layouts/navigation-icons/CheckCircle.svg";
import promocode from "../../assets/images/layouts/navigation-icons/CodeBlock.svg";
import attorney from "../../assets/images/layouts/navigation-icons/attorney-fee-svgrepo-com.svg";
import { setLanguage } from "../../redux/Slices/languageSlice";
import { fetchTranslation } from "../../redux/Slices/translationDataSlice";
import Spinner from "../../components/shared/spinner/Spinner";
import InputComponent from "../../components/shared/input/InputComponent";
import closeIcon from "../../assets/images/layouts/navigation-icons/X (1).svg";
import { TrackServices } from "../../services/track.service";
import { toast } from "react-toastify";
import { TrackStatusDataType } from "../../interface/site.interface";

const Header = () => {
  const lp = useLangPath();
  const [userNavs, setUserNavs] = useState<boolean>(false);
  const token = getCookie("ColibriToken");
  const navigate = useNavigate();
  const dispach = useDispatch();
  const profileRef = useRef<HTMLDivElement>(null);
  const dispatch = useDispatch<AppDispatch>();
  const { userInfo } = useSelector((state: RootState) => state.userProfile);
  const [showModal, setShowModal] = useState(false);
  const [logoutConfrim, setLogoutConfrim] = useState(false);
  const [open, setOpen] = useState(false);
  const [isTrackingModalOpen, setTrackingModalOpen] = useState(false);
  const [trackQuery, setTrackQuery] = useState("");
  const [resultModalOpen, setResultModalOpen] = useState(false);
  const [searchResult, setSearchResult] = useState(null);
  const [events, setEvents] = useState<TrackStatusDataType[]>([]);

  const language = useSelector((state: RootState) => state.language.language);
  const { loading: siteLoading, data } = useSelector(
    (state: RootState) => state.translationData,
  );

  const loading = !userInfo || !data;

  const navigation = [
    { name: data?.header,                    path: lp("home") },
    { name: data?.tariffs,                   path: lp("tariffs") },
    { name: data?.updates,                   path: lp("innovations") },
    { name: data?.stores,                    path: lp("stores") },
    { name: data?.about_us,                  path: lp("about") },
    { name: data?.services_title || "Xidmətlər",   path: lp("services") },
    { name: data?.tracking_search,           path: "tracking" },
    { name: data?.contacts,                  path: lp("contact") },
  ];
  const user_navigations = [
    {
      name: data?.auth_left_sidebar_foreign_addresses,
      title: data?.auth_left_sidebar_foreign_addresses,
      path: "my-foriegn-locations",
      logo: map,
      search: false,
      info: false,
    },

    {
      name: data?.auth_left_sidebar_parcels,
      title: data?.auth_left_sidebar_parcels,
      path: "my-packages",
      logo: box,
      search: true,
      info: true,
    },
    {
      name: data?.special_order || "Sifariş et",
      title: data?.special_order || "Sifariş et",
      path: "special-order",
      logo: shoppingCart,
      search: false,
      info: false,
    },
    {
      name: data?.auth_left_sidebar_balance,
      title: data?.auth_left_sidebar_balance,
      path: "my-balance",
      logo: card,
      search: false,
      info: false,
    },
    {
      name: data?.service_debts_title || "Xidmət borcları",
      title: data?.service_debts_title || "Xidmət borcları",
      path: "service-debts",
      logo: card,
      search: false,
      info: false,
    },
    {
      name: data?.auth_left_sidebar_bank_cards || "Bank Kartlarım",
      title: data?.auth_left_sidebar_bank_cards || "Bank Kartlarım",
      path: "bank-cards",
      logo: creditCard,
      search: false,
      info: false,
    },
    {
      name: data?.auth_left_sidebar_yp_order,
      title: data?.auth_left_sidebar_yp_order,
      path: "ypOrder",
      logo: mailbox,
      search: false,
      info: false,
    },
    {
      name: data?.auth_left_sidebar_courier_order,
      title: data?.auth_left_sidebar_courier_order,
      path: "courier",
      logo: truck,
      search: false,
      info: false,
    },
    {
      name: data?.auth_left_sidebar_wolt,
      title: data?.auth_left_sidebar_wolt,
      path: "wolt",
      logo: Wolt,
      search: false,
      info: false,
    },
    {
      name: data?.auth_left_sidebar_azerpost_order,
      title: data?.auth_left_sidebar_azerpost_order,
      path: "mail",
      logo: mailbox,
      search: false,
      info: false,
    },

    {
      name: data?.auth_left_sidebar_referral_accounts,
      title: data?.auth_left_sidebar_referral_accounts,
      path: "lorem",
      logo: filePlus,
      search: false,
      info: false,
    },

    {
      name: data?.auth_left_sidebar_amazon_otp,
      title: data?.auth_left_sidebar_amazon_otp,
      path: "otp-code",
      logo: check,
      search: false,
      info: false,
    },
    {
      name: data?.auth_left_sidebar_trendyol_otp,
      title: data?.auth_left_sidebar_trendyol_otp,
      path: "trendyol-otp",
      logo: check,
    },

    {
      name: data?.auth_left_sidebar_promo_code,
      title: data?.auth_left_sidebar_promo_code,
      path: "promocode",
      logo: promocode,
      search: false,
      info: false,
    },
    {
      name: data?.auth_left_sidebar_attorney,
      title: data?.auth_left_sidebar_attorney,
      path: "attorney",
      logo: attorney,
      search: false,
      info: false,
    },

    {
      name: data?.auth_common_notifications,
      title: data?.auth_common_notifications,
      path: "notifications",
    },
  ];

  const [isCopied, setIsCopied] = useState(false);

  const handleCopyId = () => {
    navigator.clipboard
      .writeText(userInfo?.id?.toString() || "")
      .then(() => {
        setIsCopied(true);
        setTimeout(() => {
          setIsCopied(false);
        }, 2000);
      })
      .catch((err) => {
        console.error("Kopyalama xətası:", err);
      });
  };

  useEffect(() => {
    if (!userInfo) {
      dispatch(fetchUser());
    }
  }, [dispatch, userInfo]);

  useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      if (
        profileRef.current &&
        !profileRef.current.contains(event.target as Node)
      ) {
        setUserNavs(false);
      }
    };

    document.addEventListener("click", handleClickOutside);
    return () => {
      document.removeEventListener("click", handleClickOutside);
    };
  }, []);
  const handleModalClose = () => {
    setShowModal(false);
  };
  const initialRender = useRef(true);

  useEffect(() => {
    if (initialRender.current) {
      initialRender.current = false;
      if (!data) {
        dispatch(fetchTranslation());
      }
    } else {
      dispatch(fetchTranslation());
    }
  }, [dispatch, language]);
  useEffect(() => {
    if (!userInfo) {
      dispatch(fetchUser());
    }
  }, [dispatch, userInfo]);

  useEffect(() => {
    if (!data) {
      dispatch(fetchTranslation());
    }
  }, [dispatch, language]);

  const handleTrackSearch = async (e: React.FormEvent, searchType: string) => {
    e.preventDefault();

    if (searchType === "global") {
      const trackingUrl = `https://parcelsapp.com/az/tracking/${trackQuery}`;
      window.open(trackingUrl, "_blank");
      return;
    }

    try {
      const payload = { order: trackQuery };
      const response = await TrackServices.PostTrackSearch(payload);

      if (response.data.case === "warning") {
        toast.error(response.data.content);
      } else if (response.data.case === "success") {
        setTrackingModalOpen(false);
        setSearchResult(response.data);
        setEvents(response.data.events);
        setResultModalOpen(true);
      }
    } catch (error: any) {
      toast.error(error.content);
    }
  };

  if (siteLoading || !data) {
    return (
      <div className={styles.spinnerContainer}>
        <Spinner size="large" />
      </div>
    );
  }

  return (
    <div id={styles.header}>
      <div className="container">
        <div className={styles.header}>
          <div className={styles.logo}>
            <Link to={"/"}>
              <img src={logo} alt="colibri" />
            </Link>
          </div>

          <div className={styles.navbar}>
            <ul className={styles.nav_list}>
              {navigation.map((nav, idx) => {
                return (
                  <li key={idx} className={styles.list}>
                    <NavLink
                      className={({ isActive }) =>
                        isActive
                          ? `${styles.navlink} ${styles.active}`
                          : styles.navlink
                      }
                      to={nav.path}
                      end={nav.path === lp("home")}
                      onClick={(e) => {
                        if (nav.path === "tracking") {
                          e.preventDefault();
                          setTrackingModalOpen(true);
                        }
                      }}
                    >
                      {({ isActive }) => (
                        <>
                          {isActive && <div className={styles.dot}></div>}
                          {nav.name}
                        </>
                      )}
                    </NavLink>
                  </li>
                );
              })}
            </ul>

            <div className={styles.offcanvas_all}>
              <button
                className={styles.OffcanvasBtn}
                onClick={() => setOpen(true)}
              >
                {" "}
                <img src={OffcanvasIcon} alt="OffcanvacBtn" />{" "}
              </button>

              <Offcanvas isOpen={open} onClose={() => setOpen(false)}>
                <div className={styles.Offcanvas_inside}>
                  {navigation.map((nav, idx) => {
                    return (
                      <li key={idx} className={styles.list}>
                        <NavLink
                          className={({ isActive }) =>
                            isActive
                              ? `${styles.navlink} ${styles.active}`
                              : styles.navlink
                          }
                          to={nav.path}
                          end={nav.path === lp("home")}
                          onClick={(e) => {
                            if (nav.path === "tracking") {
                              e.preventDefault();
                              setTrackingModalOpen(true);
                              setOpen(false);
                            }
                          }}
                        >
                          {({ isActive }) => (
                            <>
                              {isActive && <div className={styles.dot}></div>}
                              {nav.name}
                            </>
                          )}
                        </NavLink>
                      </li>
                    );
                  })}
                </div>
              </Offcanvas>
            </div>
          </div>

          <div className={styles.profile_all}>
            {token && (
              <div
                className={styles.note_button}
                onClick={() => navigate("/account/notifications")}
              >
                <div className={styles.img}>
                  <img src={bell} alt="bell" />
                  {userInfo?.read_notification_count !== 0 && (
                    <div className={styles.notify_dot}></div>
                  )}
                </div>
              </div>
            )}
            <LanguageSelect />
            {token ? (
              <div className={styles.profile_details} ref={profileRef}>
                <div className={styles.user_name_button}>
                  <button
                    className={styles.user_btn}
                    onClick={() => setUserNavs(!userNavs)}
                  >
                    <div className={styles.userDetails}>
                      <div className={styles.user_name}>
                        {userInfo?.name} {userInfo?.surname}
                      </div>
                      <p className={styles.UserInfoId}>ID: C{userInfo?.id}</p>
                    </div>
                    <div className={styles.user_icon}>
                      <div className={styles.userIconWrapper}>
                        <img
                          className={styles.userIcon}
                          src={userIcon}
                          alt="user"
                        />
                        <img
                          className={styles.userIcon2}
                          src={userIcon2}
                          alt="user"
                        />
                      </div>

                      <div className={styles.barIcon}>
                        <img
                          className={styles.barIcon1}
                          src={barIcon}
                          alt="user"
                        />
                        <img
                          className={styles.barIcon2}
                          src={barIcon2}
                          alt="user"
                        />
                      </div>
                    </div>
                    {userNavs && (
                      <div className={styles.navigations_card}>
                        {
                          <ul className={styles.admin_panel_navs}>
                            <li
                              style={{
                                display: "flex",
                                alignItems: "center",
                                justifyContent: "space-between",
                                gap: "8px",
                                fontFamily: "sans-serif",
                              }}
                            >
                              <span>ID: C{userInfo?.id}</span>
                              <span
                                onClick={handleCopyId}
                                title={isCopied ? "Kopyalandı" : "Kopyala"}
                                style={{
                                  background: "transparent",
                                  border: "1px solid #ddd",
                                  borderRadius: "4px",
                                  padding: "4px 8px",
                                  cursor: "pointer",
                                  display: "flex",
                                  alignItems: "center",
                                  justifyContent: "center",
                                  transition: "all 0.2s ease",
                                  color: "#666",
                                  fontWeight: 600,
                                }}
                                onMouseEnter={(e) => {
                                  e.currentTarget.style.background = "#f5f5f5";
                                  e.currentTarget.style.borderColor = "#999";
                                }}
                                onMouseLeave={(e) => {
                                  e.currentTarget.style.background =
                                    "transparent";
                                  e.currentTarget.style.borderColor = "#ddd";
                                }}
                              >
                                {isCopied ? (
                                  <svg
                                    width="16"
                                    height="16"
                                    viewBox="0 0 16 16"
                                    fill="none"
                                  >
                                    <path
                                      d="M13.5 4L6 11.5L2.5 8"
                                      stroke="currentColor"
                                      strokeWidth="2"
                                      strokeLinecap="round"
                                      strokeLinejoin="round"
                                    />
                                  </svg>
                                ) : (
                                  <svg
                                    width="16"
                                    height="16"
                                    viewBox="0 0 16 16"
                                    fill="none"
                                  >
                                    <rect
                                      x="5"
                                      y="5"
                                      width="9"
                                      height="9"
                                      rx="1"
                                      stroke="currentColor"
                                      strokeWidth="1.5"
                                    />
                                    <path
                                      d="M3 10.5V2.5C3 1.94772 3.44772 1.5 4 1.5H10"
                                      stroke="currentColor"
                                      strokeWidth="1.5"
                                    />
                                  </svg>
                                )}
                              </span>
                            </li>
                            {user_navigations.map((un, idx) => {
                              return un.path === "lorem" ? (
                                <div
                                  key={idx}
                                  onClick={() => setShowModal(true)}
                                >
                                  <li className={styles.admin_nav_list}>
                                    <img src={un.logo} alt="logo" />
                                    <p>{un.name}</p>
                                  </li>
                                </div>
                              ) : (
                                un.path !== "notifications" && (
                                  <Link key={idx} to={`/account/${un.path}`}>
                                    <li className={styles.admin_nav_list}>
                                      <img src={un.logo} alt="logo" />
                                      <p>{un.name}</p>
                                    </li>
                                  </Link>
                                )
                              );
                            })}
                            <div onClick={() => setLogoutConfrim(true)}>
                              <li className={styles.admin_nav_list}>
                                <img src={logoutIcon} alt="logo" />
                                <p>{data?.auth_logout_title}</p>
                              </li>
                            </div>
                          </ul>
                        }
                      </div>
                    )}
                  </button>
                </div>
              </div>
            ) : (
              <div className={styles.registration_buttons}>
                <MainButton
                  className={styles.login_btn}
                  text={data?.login_title}
                  onClick={() => {
                    navigate("/auth");
                    dispach(setIsLogin(true));
                    dispach(setIsRegister(false));
                    dispach(setIsUserStatus(false));
                    dispach(setIsMessage(false));
                    dispach(setIsChangePassword(false));
                    dispach(setIsForgetPassword(false));
                  }}
                />
                <MainButton
                  className={styles.register_btn}
                  text={data?.registration_title}
                  onClick={() => {
                    navigate("/auth");
                    dispach(setIsRegister(false));
                    dispach(setIsLogin(false));
                    dispach(setIsUserStatus(true));
                    dispach(setIsMessage(false));
                    dispach(setIsChangePassword(false));
                    dispach(setIsForgetPassword(false));
                  }}
                />
              </div>
            )}
          </div>
        </div>
      </div>
      <ReferalModal visible={showModal} onClose={handleModalClose} />
      <LogoutModal
        logoutConfrim={logoutConfrim}
        setLogoutConfrim={setLogoutConfrim}
      />
      {isTrackingModalOpen && (
        <div className={styles.TrackOverlay}>
          <div className={styles.TrackModal}>
            <button
              className={styles.closeBtn}
              onClick={() => setTrackingModalOpen(false)}
            >
              <img src={closeIcon} alt="" />
            </button>
            <h1>{data?.tracking_search}</h1>
            <form
              onSubmit={(e) => e.preventDefault()}
              className={styles.trackSearch}
            >
              <InputComponent
                type="text"
                placeholder={data?.search}
                name="name"
                value={trackQuery}
                onChange={(e) => setTrackQuery(e.target.value)}
              />
              <div className={styles.trackBtns}>
                <MainButton
                  type="button"
                  text={data?.search_global}
                  className={styles.gloabalBtn}
                  onClick={(e) => handleTrackSearch(e, "global")}
                />
                <MainButton
                  type="button"
                  text={data?.search_colibri}
                  className={styles.ColibriBtn}
                  onClick={(e) => handleTrackSearch(e, "colibri")}
                />
              </div>
            </form>
          </div>
        </div>
      )}

      {resultModalOpen && searchResult && (
        <div className={styles.tracksearchModalOverlay}>
          <div className={styles.tracksearchModalContent}>
            <button
              className={styles.closeBtn}
              onClick={() => {
                setTrackingModalOpen(true);
                setResultModalOpen(false);
              }}
            >
              <img src={closeIcon} alt="" />
            </button>
            <h2>Axtarış Nəticəsi</h2>
            {events?.length > 0 ? (
              <div className={styles.tableContainer}>
                <table className={styles.tracksearchTable}>
                  <thead>
                    <tr>
                      <th>{data?.status}</th>
                      <th>{data?.auth_courier_date}</th>
                    </tr>
                  </thead>
                  <tbody>
                    {events?.map((event, idx) => (
                      <tr key={idx}>
                        <td>{event.status}</td>
                        <td>{event.date}</td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            ) : (
              <p>{data?.auth_no_data_in_section}</p>
            )}
          </div>
        </div>
      )}
    </div>
  );
};

export default Header;
